@if (mathForm) {
  <div class="form-container" [formGroup]="mathForm">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <div class="control-div">
          <div class="control-label-container">
            <label class="control-label"> Name </label>
          </div>
          <clickatell-form-validation [controlName]="'name'"
          [form]="mathForm"></clickatell-form-validation>
          <input class="control-input" activeForm [activeForm]="mathForm" id="name" [formControlName]="'name'"
            placeholder="Enter a name" />
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Description </label>
            </div>
            <clickatell-form-validation [controlName]="'description'"
            [form]="mathForm"></clickatell-form-validation>
            <input class="control-input" activeForm [activeForm]="mathForm" id="description"
              [formControlName]="'description'" placeholder="Enter a description" />
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Expression </label>
              </div>
              <clickatell-form-validation [controlName]="'expression'"
              [form]="mathForm"></clickatell-form-validation>
              <input class="control-input" activeForm [activeForm]="mathForm" id="expression"
                [formControlName]="'expression'" placeholder="Enter expression" />
              </div>
            </ng-container>
          </clickatell-expansion-panel>
          <clickatell-expansion-panel>
            <ng-container header>
              <mat-panel-title>
                Variables
              </mat-panel-title>
            </ng-container>
            <ng-container body>
              <div class="control-div">
                <div class="addBtnContainer">
                  <button class="addIcon" (click)="addVariable()">Add variable</button>
                </div>
              </div>
              <clickatell-form-validation [controlName]="'variables'"
              [form]="mathForm"></clickatell-form-validation>
              <ng-container formArrayName="variables">
                @for (stringsForm of mathForm?.controls['variables']?.controls; track stringsForm; let i = $index) {
                  <div class="control-div"
                    >
                    <ng-container [formGroup]="stringsForm">
                      <clickatell-form-validation [controlName]="'key'"
                      [form]="stringsForm"></clickatell-form-validation>
                      <clickatell-form-validation [controlName]="'value'"
                      [form]="stringsForm"></clickatell-form-validation>
                      <div class="variables">
                        <div class="control-div">
                          <input class="control-input" activeForm [activeForm]="mathForm" id="key+{{i}}"
                            [formControlName]="'key'" placeholder="Enter key" />
                          </div>
                          <div class="control-div">
                            <input class="control-input" activeForm [activeForm]="mathForm" id="value+{{i}}"
                              [formControlName]="'value'" placeholder="Enter value" />
                            </div>
                            <div>
                              <button class="deleteIcon" (click)="deleteVariable(i)"></button>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    }
                  </ng-container>
                </ng-container>
              </clickatell-expansion-panel>
              <clickatell-expansion-panel>
                <ng-container header>
                  <mat-panel-title>
                    Logic
                  </mat-panel-title>
                </ng-container>
                <ng-container body>
                  <div class="control-result">
                    <div class="control-result-header">
                      Yes
                    </div>
                    <div class="control-result-container">
                      <div class="control-div">
                        <label class="control-label">
                          <span class="pont-to">Point To</span>
                          <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                        </label>
                        @if (nodeFlowDetails) {
                          <next-selector [canEditFlows]="canEdit.canEditFlows"
                            [selectorType]="'both'"
                            [flowSteps]="nodeFlowDetails.currentFlowSteps"
                            [flows]="nodeFlowDetails.flows"
                            [name]="'yes'"
                            [form]="mathForm"
                            [stepId]="nodeFlowDetails.stepId">
                          </next-selector>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="control-result">
                    <div class="control-result-header">
                      No
                    </div>
                    <div class="control-result-container">
                      <div class="control-div">
                        <label class="control-label">
                          <span class="pont-to">Point To</span>
                          <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                        </label>
                        @if (nodeFlowDetails) {
                          <next-selector [canEditFlows]="canEdit.canEditFlows"
                            [selectorType]="'both'"
                            [flowSteps]="nodeFlowDetails.currentFlowSteps"
                            [flows]="nodeFlowDetails.flows"
                            [name]="'no'"
                            [form]="mathForm"
                            [stepId]="nodeFlowDetails.stepId">
                          </next-selector>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="control-result">
                    <div class="control-result-header">
                      Error
                    </div>
                    <div class="control-result-container">
                      <div class="control-div">
                        <label class="control-label">
                          <span class="pont-to">Point To</span>
                          <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                        </label>
                        @if (nodeFlowDetails) {
                          <next-selector [canEditFlows]="canEdit.canEditFlows"
                            [selectorType]="'both'"
                            [flowSteps]="nodeFlowDetails.currentFlowSteps"
                            [flows]="nodeFlowDetails.flows"
                            [name]="'error'"
                            [form]="mathForm"
                            [stepId]="nodeFlowDetails.stepId">
                          </next-selector>
                        }
                      </div>
                    </div>
                  </div>
                </ng-container>
              </clickatell-expansion-panel>
            </div>
          }